import { GOT_SOCKET_MESSAGE, WS_CONNECTED, WS_DISCONNECTED } from './actionTypes'

export const wsConnected = () => ({
  type: WS_CONNECTED
})

export const wsDisconnected = () => ({
  type: WS_DISCONNECTED
})

export const gotSocketMessage = message => ({
  type: GOT_SOCKET_MESSAGE,
  payload: message
})
